const config = {
  //API ENDPOINTS
  AUTH_ENDPOINT: "Auth",
  USER_ENDPOINT: "user",
  STUDENT_ENDPOINT: "student",
  COURSES_ENDPOINT: "course",
  LOOKUP_ENDPOINT: "Lookup",
  SCIENTIFIC_SPECIALIZATION_ENDPOINT: "scientific-specialization",
  CERTIFICATE_ENDPOINT: "certificate",
  GALLERY_ENDPOINT: "gallery",
  CATEGORY_ENDPOINT: "category",
  TOTAL_ENDPOINT: "total",
  COACH_ENDPOINT: "coach",
  LESSON_ENDPOINT: "lesson",
  SETTINGS_ENDPOINT: "settings",
  ACTIVITIES_ENDPOINT: "activity",
  ADMINISTRATIVE_STAFF_ENDPOINT: "administrative-staff",

  //LOCAL STORAGE KEYS
  TOKEN_KEY: "Di_token",
  REFRESH_TOKEN_KEY: "refreshToken",
  LANGUAGE_KEY: "lang",
  LANGUAGE: "language",
  THEME_KEY: "theme",
  DIRECTION_KEY: "dir",
  BACK_URL: "back_url",
  NOT_VERIFIED: "not_verified",
  //CONSTANT
  API_KEY: "F7158EC0C2BB4E8383EB96C24E3C5A92",

  API_URL: process.env.REACT_APP_API_ENDPOINT,
};

const environment = {
  ...config,
};

export default environment;
